export default __webpack_public_path__ + "static/media/01AW2JAN66.4b5ff146.jpg";